////////LIBRARY/////////
import update from 'immutability-helper'
///////COMPONENTS///////
import extendUpdate from '../../helpers/extendUpdate'
import ActionsTypes from '../../constants/ActionsTypes'

extendUpdate(update)

const salesByArticleHistoryManager = {
	[ActionsTypes.GET_SALES_BY_ARTICLE_HISTORY]: (state) =>
		update(state, {
			salesByArticleHistoryManager: {
				isLoading: {
					$set: true,
				},
				items: {
					$set: [],
				},
				itemCatalog: {
					$set: {},
				},
			},
			columns: {
				isSearchfieldUpdated: {
					$set: false,
				},
				currentDir: {
					$set: '',
				},
				currentColumn: {
					$set: '',
				},
			},
		}),
	[ActionsTypes.GET_SALES_BY_ARTICLE_HISTORY_SUCCESS]: (state, payload) => {
		const paging = {
			totalElements: payload.data.headerContent.contentPagined.totalElements,
			totalPages: payload.data.headerContent.contentPagined.totalPages,
		}

		return update(state, {
			salesByArticleHistoryManager: {
				isLoading: {
					$set: false,
				},
				items: {
					$set: payload.data.headerContent.contentPagined.content,
				},
				paging: {
					$set: paging,
				},
				header: {
					$set: payload.data.headerParam.filters,
				},
			},
		})
	},
	[ActionsTypes.GET_SALES_BY_ARTICLE_HISTORY_FAILURE]: (state, payload) =>
		update(state, {
			salesByArticleHistoryManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.RESET_SALES_BY_ARTICLE_ITEMS]: (state, _payload) => {
		return update(state, {
			salesByArticleHistoryManager: {
				items: {
					$set: [],
				},
			},
		})
	},
	[ActionsTypes.SET_TRANSACTION_BY_ARTICLE_NUMBER]: (state, payload) => {
		let transactionNumber = payload.transactionNumber
		return update(state, {
			salesHistoryManager: {
				transactionNumber: {
					$set: transactionNumber,
				},
			},
		})
	},
	[ActionsTypes.SET_PROMOTION_BY_ARTICLE_NUMBER]: (state, payload) => {
		let promotionNumber = payload.promotionNumber
		return update(state, {
			scheduledPromoManager: {
				promotionNumber: {
					$set: promotionNumber,
				},
			},
		})
	},
}

export default salesByArticleHistoryManager
